import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';
import { parseWithEndTag } from './baseParser';

class HeaderTagParser implements TagParser {
  tag = 'kop_aan';

  parse(text: string) {
    const endTag = 'kop_uit';
    const parsedTextResult = parseWithEndTag(text, endTag);

    return {
      html: `<span class="font-bold text-primary-900 text-3xl">${parsedTextResult.parsedText}</span>`,
      consumedLength: parsedTextResult.consumedLength,
    };
  }
}

ParserRegistry.register(new HeaderTagParser());
